import React, { useEffect } from "react";
import Navbar from "../../components/main/Navbar";
import SearchHeader from "../../components/main/SearchHeader";
import { AdminLogStateContext } from "../../context/AdminDashboard/AdminLogContext";
import Log from "../../components/adminPage/Log";
import Pagination from "../../components/main/Pagination";
import Loading from "../../components/atoms/Loading";

const AdminLog = () => {
  const {
    AdminLog,
    onLog,
    BtnlogSearch,
    logtext,
    loaded,
    countallPge,
    pagenumber,
    changePage,
    adminName,
  } = AdminLogStateContext();

  // Retrieve the 'id' parameter from the URL
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    // Fetch admin log data when the component mounts or 'id' changes
    const id = urlParams.get("id");
    onLog(id);
  }, []);

  return (
    <div className="h-100">
      <Navbar titles={["کاربر‌ها", "فهرست مدیران", "تاریخچه فعالیت"]} />
      <div
        className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px mb-7.5px "
        dir="rtl">
        <SearchHeader
          title="تاریخچه فعالیت"
          buttnText="بازگشت"
          person={adminName}
          placeholder="جست و جو: توضیحات فعالیت"
          buttonSearch={BtnlogSearch}
          gettext={logtext}
          path={"/admin/user/admins"}
          borderBlue="border-blue border-1"
        />
        {/* Conditional rendering of loading indicator or log data */}
        {!loaded ? (
          <Loading height={"h-512"} />
        ) : (
          <>
            <Log
              loaded={loaded}
              dataLog={AdminLog}
              emptyText="تاریخچه‌ای یافت نشد."
              Hempty="h-512"
            />
            <Pagination
              changePage={changePage}
              countAll={countallPge}
              currentPage={pagenumber}
            />
          </>
        )}
      </div>
    </div>
  );
};
export default AdminLog;
